import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Grid, Icon, Header } from 'semantic-ui-react';
import Archivi from './Archivi';
import Filtro from './Filtro';
import { ApplicationState } from '../..';
import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { ai } from '../../../application-insight/telemetryService';

const connector = connect(
    (state: ApplicationState) => ({
        anagrafica: state.core.anagrafiche.anagrafica!,
    })
)
type PropsFromRedux = ConnectedProps<typeof connector>

type ArchiviazioneProps = PropsFromRedux

class Archiviazione extends React.Component<ArchiviazioneProps> {
    render() {
        const { anagrafica } = this.props;
        return (                
            <Grid stackable centered>
                <Grid.Row>
                    <Header as='h2' textAlign='center'>
                        <Icon name='file alternate outline' />
                        <Header.Content>
                            Archiviazione
                            <Header.Subheader>{anagrafica.ragioneSociale}</Header.Subheader>
                        </Header.Content>
                    </Header>
                </Grid.Row>
                <Filtro />
                <Grid.Row>
                    <Grid.Column mobile={16} tablet={15} computer={15}>
                        <Archivi />
                    </Grid.Column>
                </Grid.Row>
            </Grid>
        );
    }
}

export default connector(withAITracking(ai.reactPlugin, Archiviazione, "Archiviazione"));